import React, { useEffect, useState } from "react";
import { Box, Button, InputLabel, Link, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import IndexService from "../../Services/http/IndexService";
import "./loginForm.scss";

const VerificationCodeForm = ({ token, onLoginSuccess }) => {
  const { t } = useTranslation("verificationCodeForm");
  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('not_found');

  const handleCodeChange = (event) => {
    setCode(event.target.value);
  };

  useEffect(() => {
    sendVerificationCode();
  }, []);

  const sendVerificationCode = () => {
    setErrorMessage('');
    IndexService.sendVerificationCodeByEmail(token);
  };

  const verifyVerificationCode = async () => {
    setErrorMessage('');
    const res = await IndexService.verifyVerificationCode(token, code);
    if (res['message'] === 'success') {
      onLoginSuccess();
    } else {
      setErrorMessage(res['message']);
    }
  };

  const messagesByError = {
    'not_found': t('errors.invalid'),
    'invalid_code': t('errors.invalid'),
    'expired_code': t('errors.expired'),
    'default': t('errors.generic')
  };

  return (
    <Box sx={{ mt: 3 }}>
      <p style={{ textAlign: 'center' }}>{t('sent')}</p>
      <InputLabel>{t('enterCode')}</InputLabel>
      <TextField
        id="code"
        variant="outlined"
        value={code}
        onChange={handleCodeChange}
      />
      <Button
        disabled={code === ''}
        onClick={verifyVerificationCode}
        className='button-login'
        sx={{ mt: 3 }}
      >
        {t('next')}
      </Button>
      <Link
        onClick={sendVerificationCode}
        underline='none'
        sx={{ cursor: 'pointer', float: 'right', mt: 3 }}
      >
        {t('resend')}
      </Link>
      {(errorMessage && errorMessage !== '') && (
        <p style={{ color: 'red' }}>
          {messagesByError[errorMessage] || messagesByError['default']}
        </p>
      )}
    </Box>
  );
};

export default VerificationCodeForm;
